import axios from 'axios';
import { SERVER } from '../../constants/networkUrls';
import apiConfig from '../trustBuilder/Auth/services/apiConfig';
 
const getQRCodeAuthToken = (authCode, qrSessionId) => {
    return new Promise((resolve, reject) => {
        if (!authCode || !qrSessionId) {
            return reject(new Error("authCode and qrSessionId are required"));
        }

        const hostname = window?.location?.hostname;
        const environmentConstants = apiConfig.setEnvironmentURLs(hostname);
        const getTokenURL = `${SERVER.API_BASE_URL}${SERVER.SERVICES.QR_AUTHORIZATION}/${authCode}/${qrSessionId}`;
        console.log("getTokenURL is",getTokenURL);
        const authConfig = {
            headers: {
                "X-API-KEY": environmentConstants.apiKey,
                'Content-Type': 'application/json',
            }
        };

        axios.get(getTokenURL, authConfig)
            .then(response => {
                console.log("QR Auth Token response:", response);
                resolve({ status: "success", data: response.data });
            })
            .catch(error => {
                console.error("QR Auth Token error:", error);
                reject({ status: "failure", error: error.response?.data || error.message });
            });
    });
};

export {getQRCodeAuthToken}
